import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

import { ShareUrl } from '../../../screens/Promotion/PromotionRewardsScreen';

import styles from './FallbackActionGroup.module.css';

export const FallbackActionGroup = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <p className={styles.disclaimer}>
        {t(
          'If the "Accept Invitation" button does not work in the current app, please click the button below to copy link and paste it in an external browser.',
        )}
      </p>
      <ShareUrl />
      <p className={styles.disclaimer}>
        {t(
          'Scanning the following QR Code can also open link in an external browser.',
        )}
      </p>
      <QRCodeSVG
        value={window.location.href}
        size={220}
        className={styles.qrcode}
      />
      <div className={styles.learnMore}>
        {t('Learn more about JOYAJOY')}
        <a
          className={styles.url}
          href="https://joyajoy.com"
          target="_blank"
          rel="noreferrer"
        >
          www.JOYAJOY.com
        </a>
      </div>
    </div>
  );
};
